import Courses from '../components/courses';
import CourseModules from '../components/courses/modules';
import CourseModule from '../components/courses/modules/module';

export const CourseRoutes = [
  { path: '/courses', element: <Courses /> },
  { path: '/courses/modules', element: <CourseModules /> },
  { path: '/courses/modules/module', element: <CourseModule /> }
];
